import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchCompliancePredesResdesMailboxMismatch = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getCompliancePredesResdesMailboxMismatch',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchCompliancePredesResdesMailboxMismatch;
